import React from 'react';
import { Button, Col, ListGroup, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const ProceedingItem = ({proceeding, setData}) => {
    //Store
    const paymentTypes = useSelector( state => state.params.paymentTypes );
    //Manejo la selección
    const handleSelect = paymentType => {
        //Seteo
        setData({
            show: true,
            proceeding,
            paymentType
        })
    }
    //Render
    return (
        <ListGroup.Item>
            <Row className="mb-2">
                <Col md={8}>
                    <h4>
                        <strong>{ proceeding.nro_expediente }</strong>
                        &nbsp;|&nbsp;
                        <small>{ proceeding.juzgado.dscr }</small>
                    </h4>
                    {`${proceeding.acto} C/ ${proceeding.dema} S/ ${proceeding.tipo_proceso}`}
                </Col>
                <Col md={4}>
                    <Row>
                    {
                        paymentTypes ? (
                            paymentTypes.map( (paymentType, index) => (
                                <div className={`col-md-${ index === 0 ? '12 mt-2 mt-md-0' : '6'}`} key={`pr${paymentType.id}`} >
                                    <Button 
                                        variant={paymentType.style} 
                                        size="sm" 
                                        block 
                                        className="mb-2" 
                                        onClick={() => handleSelect(paymentType)}
                                    >
                                        <strong>{ paymentType.name }</strong>
                                    </Button>
                                </div>
                            ))
                        ) : null
                    }
                    </Row>
                </Col>
            </Row>
        </ListGroup.Item>
    );
};

export default ProceedingItem;